module.exports = __webpack_public_path__ + "static/media/svg-2.b28fcc81.svg";